// Pénombre des zones ABRITÉES (chantier Pharaon premium, 22/07) : une case est « abritée » quand
// une tuile couvrante (qui bloque la lumière du ciel) existe STRICTEMENT plus haut dans sa
// colonne. La case couvrante elle-même reste au jour : c'est la surface éclairée ; tout ce qui est
// dessous s'enfonce dans l'ombre — l'intérieur d'une pyramide, un tunnel, le fond d'un lac.
// Module PUR (aucun DOM) : render.ts s'en sert pour draper le voile sombre et faire flamboyer les
// sources de lumière abritées ; testé en Node (tests/shelter.test.ts).
import { T } from '../shared/types'

// Tuiles qui bloquent la lumière du ciel. Volontairement SANS : échelle, corde, barrière (grille
// ajourée), trampolines (toile fine), stations/interrupteur (objets ajourés), téléporteurs — le
// jour passe autour. La FAUSSE brique couvre : elle SE VOIT comme une brique (ne pas la trahir).
const COVERING = new Set<number>([
  T.Brick, T.Concrete, T.FalseBrick, T.Ice, T.Sand, T.Crumble, T.DoorClosed,
  T.Lava, T.Water, T.RampUpRight, T.RampUpLeft,
])

/** Masque par case : 1 = abritée (au moins une tuile couvrante au-dessus dans sa colonne). */
export function shelterMask(terrain: ArrayLike<number>, cols: number): Uint8Array {
  const out = new Uint8Array(terrain.length)
  for (let c = 0; c < cols; c++) {
    let covered = false
    for (let i = c; i < terrain.length; i += cols) {
      if (covered) out[i] = 1
      else if (COVERING.has(terrain[i]!)) covered = true
    }
  }
  return out
}

/** Égalité de deux masques — le voile ne se re-bake que si le masque a VRAIMENT changé
 *  (creuser dans un tunnel déjà sombre ne change rien). */
export function sameMask(a: Uint8Array | null, b: Uint8Array): boolean {
  if (!a || a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false
  return true
}
